import { funlidayRequest } from './main';

export const getRewardPoints = (offset = 0, limit = 20) =>
  funlidayRequest.get('v2/points');
